import React from 'react';
import { Shield, Zap } from 'lucide-react';
import { Link, Outlet } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const MainLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-stone-100">
      <Helmet>
        <title>RedVsBlue - Cybersecurity Tools Repository</title>
        <meta name="description" content="A comprehensive collection of Red Team and Blue Team cybersecurity tools and attack scenarios for security professionals." />
        <meta property="og:title" content="RedVsBlue - Cybersecurity Tools Repository" />
        <meta property="og:description" content="Explore the latest Red Team and Blue Team cybersecurity tools, techniques and attack scenarios." />
        <meta property="og:url" content="https://redvsblue.hackernoob.tips/" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://redvsblue.hackernoob.tips/logo192.png" />
        <link rel="canonical" href="https://redvsblue.hackernoob.tips/" />
      </Helmet>
      
      <header className="bg-stone-50 shadow-sm border-b border-stone-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between h-16">
            <div className="flex">
              <div className="flex-shrink-0 flex items-center">
                <Link to="/" className="flex items-center">
                  <div className="flex items-center">
                    <Shield className="h-8 w-8 text-blue-600" />
                    <Zap className="h-8 w-8 text-red-600 -ml-4" />
                  </div>
                  <span className="ml-2 text-xl font-bold text-gray-900">RedVsBlue</span>
                </Link>
              </div>
              <nav className="ml-6 flex space-x-8">
                <Link
                  to="/"
                  className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                >
                  Home
                </Link>
                <Link
                  to="/tools"
                  className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                >
                  Security Tools
                </Link>
                <Link
                  to="/about"
                  className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
                >
                  About
                </Link>
              </nav>
            </div>
          </div>
        </div>
      </header>
      
      <main>
        <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
          <Outlet />
        </div>
      </main>
      
      <footer className="bg-stone-50 border-t border-stone-200">
        <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
          <div className="text-center text-sm text-gray-500">
            <p>&copy; {new Date().getFullYear()} RedVsBlue - Cybersecurity Tool Repository</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MainLayout; 